import { combineReducers } from "redux";
import { reducer as form } from "redux-form";
import { reducer as toastr } from "react-redux-toastr";

import user from "./user";
import token from "./token";
import selected_project from "./selected_project";
import job_definations from "./job_definitions";
import projects from "./projects";
import sidebar from "./sidebar";
import usermgt from "./user_management";
import dashboard from "./dashboard";
import selected_jd from "./selected_jd";

import newness from "./newness";
import training from "./training";
import classnewness from "./classnewness";
import robustness from "./robustness";
import classrobustness from "./classrobustness";
import settings from "./settings";
import cloudstorage from "./cloudstorage";
import localstorage from "./localstorage";
import logged_user from "./logged_user";
import dataviewer from "./dataviewer";
import filedata from "./filedata";
import selected_file from "./filedata";
import job from "./job";
import job_info from "./job_info";
import job_log from "./job_log";
import generator_config from "./generator";
import twin from "./twin";
import twincmp from "./twincmp";
import releaseinfo from "./releaseinfo";
import modelrelease from "./modelrelease";
import priorreleases from "./priorreleases";

const rootReducer = combineReducers({
  user,
  token,
  selected_project,
  form,
  toastr,
  projects,
  sidebar,
  usermgt,
  dashboard,
  training,
  newness,
  classnewness,
  robustness,
  classrobustness,
  settings,
  cloudstorage,
  localstorage,
  logged_user,
  dataviewer,
  filedata,
  selected_file,
  selected_jd,
  job_definations,
  job,
  job_info,
  job_log,
  generator_config,
  twin,
  twincmp,
  releaseinfo,
  modelrelease,
  priorreleases
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/reducers/index.js